import { Drawer } from "@material-ui/core";
import styled from "styled-components";
import { TypeAppliedTheme } from "@src/Stores/Themes/types";

export const STDrawer = styled(Drawer).attrs({
  classes: { paper: "DrawerPaper" },
})`
  width: 240px;

  && {
    .DrawerPaper {
      width: 240px;
      top: 65px;
      z-index: 0;
      background-color: ${(props: { theme: TypeAppliedTheme }) => props.theme.secondaryColor};
    }
  }
`;
